export default __webpack_public_path__ + "static/media/blog.0172fcb2.jpeg";